import { render, staticRenderFns } from "./RadioField.vue?vue&type=template&id=4e2cf1d4"
import script from "./RadioField.vue?vue&type=script&lang=js"
export * from "./RadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports